<div id="ManipAlgebraTilesContainer" #container>
    <div id="AlgebraTilesCanvas" class="ManipAlgebraTilesCanvas" #canvas></div>

    <div *ngIf="displaySummary" class="label_expression RenderMath" [innerText]="expression"></div>

    <div *ngIf="!(hideStudentManipControlBar | async)" class="ManipAlgebraTilesBar StudentManipControlBar StudentManipControlBarBottomOnMobile">
       
        <div class="kh-bottom-bar-container w-100 d-flex justify-content-center align-content-center kh-horizontal-scroll-bar ">
            <div class="kh-bottom-bar-content-container w-100 d-flex justify-content-between align-items-center  flex-shrink-0">
                <div class="w-100 d-flex align-items-center   flex-shrink-0 flex-grow-1">
                    <div class=" d-flex align-items-center kh-justify-content-align-controls  flex-shrink-0 flex-grow-1">
                    <button type="button" #add
                        class="btn-md kh-blue-button white kh-lg-title-text text-uppercase  m-kh-2  flex-shrink-0 kh-secondory-controls"
                        (click)="openAddTileModal()">{{ 'MANIP_ALGEBRA_TILES.ADD_TILE' | translate }}</button>
                          <div class="SelectedTileButtons  flex-shrink-0" *ngIf="selectedObject">
                        <button type="button" class="btn btn-invis btn-md " (click)="rotate()">
                            <fa-icon [icon]="['fas','redo-alt']"></fa-icon>
                        </button>
                        <button type="button" class="btn btn-invis btn-md font-weight-bold"
                            (click)="toggleNegative()">+/-</button>
                        <button type="button" class="btn btn-invis btn-md " (click)="duplicate()">
                            <fa-icon [icon]="['fas','copy']"></fa-icon>
                        </button>
                        <button type="button" class="btn btn-invis btn-md" (click)="delete()">
                            <fa-icon [icon]="['fas','trash-alt']"></fa-icon>
                        </button>
                    </div>
                    </div>
                    <div class="justify-content-end kh-submit-width  flex-shrink-0 ">
                        <button
                        class="btn-md kh-green-button kh-green-accessible white kh-lg-title-text text-uppercase kh-no-wrap  manipulative-submit-button"
                        type="button" *ngIf="tiles.length > 0 && !questionClosed" (click)="submit(expression)" [class.animated]="selectedObject"><img
                            src="https://staticcontent.knowledgehook.com/content/icons/question/submitarrow-onprimary.svg">
                    </button>
                    </div>                  
                </div>              
            </div>
        </div>
    </div>
</div>